import styled from 'styled-components';

export const OrderFilterTypeStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
